<div class="nt-main-container">
    <mat-card oneCard class="nt-one-card">
        <mat-card-title>
            <span class="mat-title">Notification Title</span>
        </mat-card-title>
        <mat-card-content>
            <div class="nt-input-section">
                <p>You can also create your own title</p>
                <mat-form-field appearance="fill" oneFormField style="width: 100%; flex: 1;">
                    <mat-label>Add title (optional)</mat-label>
                    <input matInput [formControl]="notificationTitleformctrl" value=""/>
                    <button *ngIf="notificationTitleformctrl.value" one-icon-button-flat mat-flat-button matSuffix (click)="notificationTitleformctrl.setValue('')">
                      <mat-icon>clear</mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </mat-card-content>
    </mat-card>
</div>
